import React, { useEffect, useState } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Row, Col, Button, Form, Modal, TreeSelect, useCRUDController, Input } from '../../ui/ot'
import DepartmentRole from './department_role';
import { useTranslation } from 'react-i18next';

const { confirm } = Modal;
const RoleDepartment = ({
    keyPrefix = 'organization_structure.staff',
    propsForm,
    field,
    remove,
    showMode,
    name,
    value,
    onChange = () => { },
    onValueChange = () => { },
    propsRoleController,
    propsRoleOptionController,
    propsDepartmentController,
    propsDepartmentOptionController,
    ...props
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [form_] = Form.useForm();
    const form = propsForm ?? form_
    const [count, setCount] = useState(0);
    const roleController_ = useCRUDController({
        apiRoute: '/organization_structure/api/role'
    })
    const roleOptionController_ = useCRUDController({
        apiRoute: '/organization_structure/api/role_dropdown'
    })
    const roleController = propsRoleController ?? roleController_
    const roleOptionController = propsRoleOptionController ?? roleOptionController_
    useEffect(() => {
        if (roleController?.ResponseData?.length === 0) {
            roleController.getData({
                classify_structure_type_id: 0,
                classify_structure_id: 8
            })
        }
        if (roleOptionController?.ResponseData?.length === 0) {
            roleOptionController.getData({})
        }
        setTimeout(() => {
            setCount(pre => pre + 1)
        }, 1000)
    }, []);
    const departmentData = Form.useWatch([field?.name, 'user_role_department_data'], form)
    const departmentRoleData = (roleOptionController.ResponseData?.find(item => String(item?.role_id) === String(value))?.department_role_data.length === 0 ? departmentData : roleOptionController.ResponseData?.find(item => String(item?.role_id) === String(value))?.department_role_data) ?? []

    return (

        <Row gutter={[4, 4]} style={{ display: 'flex', justify: 'center', alignItems: 'center' }}>
            <Col span={20}>
                {roleController.ResponseData.length !== 0 && (showMode === undefined || showMode === 'role') && <>
                    <TreeSelect
                        name={name}
                        value={roleOptionController.ResponseData?.find(item => String(item?.role_id) === String(value))?.classify_structure_type_id}
                        onChange={(e) => {
                            setCount(pre => pre + 1)
                            form.setFieldValue([field?.name, 'user_role_department_data'].join('.'), [])
                            onChange({
                                ...e,
                                target: {
                                    name,
                                    value: roleOptionController.ResponseData?.find(item => String(item?.classify_structure_type_id) === String(e.target.value))?.role_id
                                }
                            })
                        }}
                        onValueChange={(e) => {
                            onValueChange({
                                ...e,
                                target: {
                                    name,
                                    value: roleOptionController.ResponseData?.find(item => String(item?.classify_structure_type_id) === String(e.target.value))?.role_id
                                }
                            })
                        }}
                        showSearch
                        style={{
                            width: '100%',
                        }}
                        dropdownStyle={{
                            maxHeight: 400,
                            overflow: 'auto',
                        }}
                        placeholder={t('select_role')}
                        allowClear
                        treeDefaultExpandAll
                        treeNodeFilterProp={"title"}
                        treeData={roleController.ResponseData}
                    />
                </>
                }
                {(departmentRoleData ?? []).length !== 0 && (showMode === undefined || showMode === 'department') && <>
                    {!props.edit &&
                        <Form.List
                            label={t('role')}
                            name={[field.name, "user_role_department_data"]}
                            rules={[
                                {
                                    required: true,
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            {(subFields, { add, remove }) => (
                                <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'end' }}>
                                    <Form.Item
                                        hidden
                                        name={[field?.name ?? '', "user_role_department_data"]}
                                    ></Form.Item>
                                    {departmentRoleData?.map((departmentRole, key) => (<>
                                        <Col span={24}
                                            key={count}
                                        >
                                            <Form.Item
                                                label={`${departmentRoleData?.[key]?.department_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem =>
                                                    itemItemItem?.language_culture_value
                                                )}${key + 1}`}
                                                name={[[field?.name, 'user_role_department_data', key].join('.'), "department_id"]}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: `此為必填項目`
                                                    }
                                                ]}
                                            >
                                                <DepartmentRole
                                                    propsForm={form}
                                                    departmentPlaceholder={'選擇' + departmentRoleData?.[key]?.department_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem =>
                                                        itemItemItem?.language_culture_value
                                                    )}
                                                    field={{ ...subFields?.[key], name: subFields?.[key]?.name ?? ([field?.name, 'user_role_department_data', key].join('.')) } ?? {}}
                                                    propsDepartmentClassifyStructureTypeId={departmentRoleData?.[key]?.classify_structure_type_id}
                                                    propsDepartmentController={propsDepartmentController}
                                                    propsDepartmentOptionController={propsDepartmentOptionController}
                                                ></DepartmentRole>
                                            </Form.Item>
                                        </Col>
                                    </>))}
                                </Row>
                            )}
                        </Form.List>
                    }
                </>}
            </Col>
            <Col span={4}>
                <Button
                    onClick={() => {
                        confirm({
                            title: '確定要刪除嗎',
                            icon: <ExclamationCircleOutlined />,
                            okText: '確定',
                            okType: 'danger',
                            cancelText: '取消',
                            onOk() {
                                remove(field.name);
                            },
                            centered: true
                        });
                    }}> {t('delete_role')}
                </Button>
            </Col>
        </Row >

    )
}
export default RoleDepartment;

